import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMg: CultureInfo = {
  name: 'mg',
  displayName: 'Malagasy',
  iso3LanguageCode: 'mlg',
  iso2LanguageCode: 'mg',
  ietfLanguageTag: 'mg',
  parent: null
};
